import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";

export default function EAdhigamInfoSection() {
  return (
    <div>
      <span className="text-sm text-muted">
        An e-Adhigam student is one who uses the tablet for 35 minutes per subject per week and attempts 2 tests (diagnostic test/remedial test/homework) per subject per week in any 3 subjects
      </span>
      <br />
      <span className="text-sm text-muted">
        An e-Adhigam teacher is one who uses the tablet for 1 hour per week & assigns 2 personalized homeworks to students
      </span>
    </div>
  );
}
